import React from "react";

import ActionIconsTableItem from "./ActionIconsTableItem";
import SelectableTable from "../../common/components/SelectableTable/SelectableTable";
import SimpleTableBadge from "../../common/components/SimpleTableBadge";
import SimpleTableItem from "../../common/components/SimpleTableItem";
import TablePagination from "../../common/components/TablePagination";

const CaseReportsTable = ({
  handleFetchTests,
  metaProps,
  tests,
  flippers,
}) => {
  return (
    <div>
      <SelectableTable
        hideCheckboxes={true}
        tableHeaders={["Participant", "Barcode", "Service", "Service date", "Result", "Status", ""]}
        filteredPaginatedItems={tests}
        itemComponents={{
          action_icons: <ActionIconsTableItem handleFetchTests={handleFetchTests} />,
          administered_at: <SimpleTableItem textPropKey="administered_at_date" subTextPropKey="administered_at_time" />,
          participant: <SimpleTableItem textPropKey="full_name" urlPropKey="edit_test_group_test_group_user_url" subTextPropKey="date_of_birth_with_age" />,
          result: <SimpleTableItem textPropKey="result" />,
          service: <SimpleTableItem textPropKey="service_label" subTextPropKey="test_location_label" />,
          status: <SimpleTableBadge textPropKey="status" />,
          uid: <SimpleTableItem textPropKey="uid" />,
        }}
        itemKeys={[
          "participant",
          "uid",
          "service",
          "administered_at",
          "result",
          "status",
          "action_icons",
        ]}
        responsive={false}
        tableStyle={{
          overflowX: "auto",
          overflowY: "visible",
          width: "100%"
        }}
      />
      <TablePagination
        containerClassName="mt-3"
        newTablesFlipperEnabled={flippers?.new_tables}
        {...metaProps}
      />
    </div>
  );
};

export default CaseReportsTable;
